import { useEffect, useState } from 'react';

import { type DefaultTheme, useTheme } from 'styled-components';

/**
 * Helper function that will tell you if the browser window is within the
 * given breakpoint. Example usage:
 *
 * const { isWithinBreakpoint: isMobile } = useBreakpoint('mobile');
 * const { isWithinBreakpoint: isDesktop } = useBreakpoint('desktop');
 */
export const useBreakpoint = (breakpoint: keyof DefaultTheme['breakpoints']) => {
    const theme = useTheme();
    const breakpointValue = theme.breakpoints[breakpoint];
    const breakPointWithoutPx = parseInt(`${breakpointValue}`);

    const [isWithinBreakpoint, setIsWithinBreakpoint] = useState(window.innerWidth <= breakPointWithoutPx);

    useEffect(() => {
        setIsWithinBreakpoint(window.innerWidth <= breakPointWithoutPx);
        function handleResize() {
            setIsWithinBreakpoint(window.innerWidth <= breakPointWithoutPx);
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [breakPointWithoutPx]);

    return { isWithinBreakpoint };
};
